import React, { useEffect, useState } from "react";
import { history } from "../appRedux/store";
import { connect } from "react-redux";
import { Form, Input, Button, message } from "antd";
import { Link } from "react-router-dom";
import { verifyAuthOtp } from "../services/users-service";
import { updateOtpVerificationStatus } from "../appRedux/actions";

const FormItem = Form.Item;

function VerifyAuthOtp(props) {
    const { form, authUser } = props;
    const [loading, setLoading] = useState(false);
    const { getFieldDecorator } = form;

    function handleSubmit(e) {
        e.preventDefault();
        form.validateFields(async (err, values) => {
            if (!err) {
                if (!loading) {
                    setLoading(true);
                    const data = {
                        email: authUser.email,
                        code: values.code,
                        mode: "AUTHENTICATORAPP",
                    };
                    try {
                        const response = await verifyAuthOtp(data); 
                        if(response.success){
                            message.success("OTP verified successfully");
                            props.updateOtpVerificationStatus();
                            history.push("/");
                        }else {
                            throw new Error("Invalid code, please try again");
                        }
                    } catch (error) {
                        message.error("Invalid code, please try again");
                        console.log("Error verifying OTP: ", error);
                    } 
                    finally {
                        setLoading(false);
                    }
                }
            }
        });
    }

    useEffect(() => {
        if (!authUser) {
            history.push("/signin");
        }
        if (authUser && authUser.otpVerified) {
            history.push("/");
        }
    }, [authUser]);

    return (
        <div className="gx-app-login-wrap">
            <div className="verify-container">
                <div>
                    <h1 className="authenticator-heading">
                        Enter the 6-digit Code from the Authenticator
                    </h1>
                </div>
                <div className="verify-container-block">
                    <div className="gx-app-login-content">
                        <Form
                            onSubmit={handleSubmit}
                        >
                            <FormItem
                                label={
                                    <span className="label-otp">
                                        Enter Code
                                    </span>
                                }
                                style={{ margin: '0px -5px 15px' }}
                            >
                                {getFieldDecorator("code", {
                                    initialValue: undefined,
                                    rules: [
                                        { required: true, message: "Please input your code!" },
                                    ],
                                })(<Input autoFocus />)}
                            </FormItem>
                            <p style={{ textAlign: 'center', fontWeight: 300, color: '#E5E5E5' }}>Try another way? <Link to={'/verify-email-otp'} >Send Code via Email</Link></p>
                        </Form>
                        <p style={{ textAlign: "center", fontWeight: 400, padding: '10px 15px' }}>
                            Enter the verification code from your Authenticator app to proceed.
                        </p>
                    </div>
                </div>
                <Button
                    block
                    type="primary"
                    loading={loading}
                    onClick={handleSubmit}
                    style={{ minHeight: '45px' }}
                >
                    {"Next"}
                </Button>
            </div>
        </div>
    )
}

const VerifyAuthenticatorCode = Form.create()(VerifyAuthOtp);

const mapStateToProps = ({ auth }) => {
    const { authUser } = auth;
    return { authUser }
};

export const mapDispatchToProps = dispatch => ({
    updateOtpVerificationStatus: (isAuthenticator) => dispatch(updateOtpVerificationStatus(isAuthenticator))
});


export default connect(mapStateToProps, mapDispatchToProps)(VerifyAuthenticatorCode);
